import CrossIcon from "../../assets/images/cross-icon.svg";
import React, { useEffect } from "react";
import PlaceholderIconSvg from "../../assets/images/avatar-placeholder-icon.svg";
import FilledStar from "../../assets/images/filled-start.svg";
import moment from "moment";
import { useTranslation } from "react-i18next";


interface HotelTestimonialBoxProps {
  setShowTestimonialBox?: (show: boolean) => void;
  showTestimonialBox?: boolean;
  selectedTestimonial?: any[];
}

const HotelTestimonialBox: React.FC<HotelTestimonialBoxProps> = ({
  setShowTestimonialBox,
  showTestimonialBox,
  selectedTestimonial = [],
}) => {
  const { t } = useTranslation();
  const testimonial = selectedTestimonial[0];

  const handleClose = (e: React.MouseEvent<HTMLDivElement>) => {
    if (setShowTestimonialBox && e.target === e.currentTarget) {
      setShowTestimonialBox(false);
    }
  };

  useEffect(() => {
    const bodyClass = "datepicker-open-with-index";
    if (showTestimonialBox) {
      document.body.classList.add(bodyClass);
    } else {
      document.body.classList.remove(bodyClass);
    }

    return () => {
      document.body.classList.remove(bodyClass);
    };
  }, [showTestimonialBox]);

  // Only a review the guest opened is shown.
  if (!testimonial) {
    return null;
  }

  const score = Number(testimonial.overall_score);

  return (
    <div
      className={`testimonial-modal ${showTestimonialBox ? "active" : ""}`}
      onClick={handleClose}
    >
      <div className="content-box" onClick={(e) => e.stopPropagation()}>
        <div className="header">
          <p>{t("view_review")}</p>
          {setShowTestimonialBox && (
            <img
              onClick={() => setShowTestimonialBox(false)}
              src={CrossIcon}
              alt="cross icon"
            />
          )}
        </div>
        <div className="content">
          <div className="intro">
            <p className="name">
              <span>{testimonial.guest_name}</span>
              <img src={PlaceholderIconSvg} alt="icon" />
            </p>
            <p className="review">
              <img src={FilledStar} alt="filled star" />
              {score > 0 && <span>{Math.round(score)}/10 . </span>}
              {testimonial.received_at && (
                <span>{moment(testimonial.received_at).format("DD.MM.YYYY")}</span>
              )}
            </p>
          </div>
          <div className="body">
            <p>{testimonial.content}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelTestimonialBox;
